import Vue from "vue";
import VueRouter from "vue-router";
import { getUserId } from "../utils/store";
import AdviserRegistration from '@/views/AdviserRegistration/index.vue'

Vue.use(VueRouter);

const userAgentInfo = navigator.userAgent;
const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
const getArr = Agents.filter((i) => userAgentInfo.includes(i));
const isMobile = !!getArr.length;

let routes;

const commonRoutes = [{
    path: "/home",
    redirect: "/home/studentclubs",
    component: () =>
        import ("../views/Home"),
    meta: {
        requiresAuth: true,
        title: "首页",
    },
    children: [{
            path: "studentclubs",
            name: "Student Clubs",
            component: () =>
                import ("../views/StudentClubs/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Student Clubs",
            },
        },
        {
            path: "adviserclubs",
            name: "Adviser Clubs",
            component: () =>
                import ("../views/AdviserClubs/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Adviser Clubs",
            },
        },
        {
            path: "schoolclubs",
            name: "School Clubs",
            component: () =>
                import ("../views/SchoolClubs/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Adviser Clubs",
            },
        },
        {
            path: "clubstudents",
            name: "Club Students",
            component: () =>
                import ("../views/ClubStudents/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Club Students",
            },
        },
        {
            path: "clubadvisors",
            name: "Club Advisors",
            component: () =>
                import ("../views/SchoolClubs/Advisers/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Club Advisors",
            },
        },
        {
            path: "clubDetail",
            name: "Club Detail",
            component: () =>
                import ("../views/ClubDetail/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Club Detail",
            },

        },
        {
            path: "discoverclubs",
            name: "Discover Clubs", 
            component: () =>
                import ("../views/DiscoverClubs/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Discover Clubs",
            },
        },
        {
            path: "clubProfile",
            name: "Club Profile",
            component: () => import("../views/ClubProfile/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Club Profile",
            },
        },
        {
            path: "findcontents",
            name: "Find Contents",
            component: () => import("../views/FindContents/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Find Contents",
            },
        },
        {
            path: "contentProfile",
            name: "Content Profile",
            component: () => import("../views/ContentProfile/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Content Profile",
            },
        },
        {
            path: "bundleDetail",
            name: "Bundle Detail",
            component: () => import("../views/BundleDetail/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Bundle Detail",
            },
        },
        {
            path: "contentOrderForm",
            name: "Content Order Form",
            component: () => import("../views/ContentOrderForm/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Content Order Form",
            },
        },
        {
            path: "contentPayment",
            name: "Content Payment",
            component: () => import("../views/ContentPayment/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Content Payment",
            },
        },
        {
            path: "contentCopy",
            name: "Content Copy",
            component: () => import("../views/ContentCopy/index.vue"),
            meta: {
                requiresAuth: false,
                title: "Content Copy",
            },
        },
        {
            path: "contentOrders",
            name: "Content Orders",
            component: () => import("../views/ContentOrders/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Content Orders",
            },
        },
        {
            path: "mycontents",
            name: "My Contents",
            component: () => import("../views/MyContents/index.vue"),
            meta: {
                requiresAuth: true,
                title: "My Contents",
            },
        },
        {
            path: "payment",
            name: "Payment",
            component: () => import("../views/Pay/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Payment",
            },
        },
        {
            path: "copyPayment",
            name: "Copy Payment",
            component: () => import("../views/CopyPayment/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Copy Payment",
            },
        },
        {
            path: "bundlepayment",
            name: "Bundle Payment",
            component: () => import("../views/BundlePayment/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Bundle Payment",
            },
        },
        {
            path: "supporttickets",
            name: "Support Tickets",
            component: () => import("../views/SupportTickets/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Support Tickets",
            },
        },
        {
            path: "subscriptionOrderForm",
            name: "Subscription Order Form",
            component: () => import("../views/SubscriptionOrderForm/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Subscription Order",
            },
        },
        {
            path: "subscriptionPayment",
            name: "Subscription Payment",
            component: () => import("../views/SubscriptionPayment/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Subscription Payment",
            },
        },
        {
            path: "subscriptionPay",
            name: "Subscription Pay",
            component: () => import("../views/SubscriptionPay/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Subscription Pay",
            },
        },
        {
            path: "subscriptionManagement",
            name: "Subscription Management",
            component: () => import("../views/SubscriptionManagement/index.vue"),
            meta: {
                requiresAuth: false,
                title: "Subscription Management",
            },
        },
        {
            path: "subscriptionOrders",
            name: "Subscription Orders",
            component: () => import("../views/SubscriptionOrders/index.vue"),
            meta: {
                requiresAuth: true,
                title: "Subscription Orders",
            },
        },
    ],
}, ];
routes = [{
        path: "/login",
        name: "Login",
        component: () =>
            import ("../views/login/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Login",
        },
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: () =>
            import ("../views/ResetPassword/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Reset Password",
        },
    },
    {
        path: "/official",
        redirect: "/official/about",
        component: () => import("../views/OfficialSite/Layout.vue"),
        meta: {
            requiresAuth: false,
            title: "eClub Official",
        },
        children: [
            {
                path: "home",
                redirect: "/official/about"
            },
            {
                path: "features",
                name: "OfficialFeatures",
                component: () => import("../views/OfficialSite/Features.vue"),
                meta: {
                    requiresAuth: false,
                    title: "eClub Features - Comprehensive Club Management",
                },
            },
            {
                path: "about",
                name: "OfficialAbout",
                component: () => import("../views/OfficialSite/About.vue"),
                meta: {
                    requiresAuth: false,
                    title: "About eClub - Transform Your School's Club Experience",
                },
            },
            {
                path: "contact",
                name: "OfficialContact",
                component: () => import("../views/OfficialSite/Contact.vue"),
                meta: {
                    requiresAuth: false,
                    title: "Contact eClub - Get in Touch",
                },
            },
            {
                path: "news",
                name: "OfficialNews",
                component: () => import("../views/OfficialSite/News.vue"),
                meta: {
                    requiresAuth: false,
                    title: "News & Updates - eClub",
                },
            },
            {
                path: "catalogue",
                name: "OfficialCatalogue",
                component: () => import("../views/OfficialSite/Catalogue.vue"),
                meta: {
                    requiresAuth: false,
                    title: "Features - eClub",
                },
            },
        ],
    },
    {
        path: "/adviser-registration",
        name: "AdviserRegistration", 
        component: () => import("../views/AdviserRegistration/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Adviser Registration",
            layout: 'blank'
        }
    },
    {
        path: "/",
        redirect: "/official/about",
        meta: {
            requiresAuth: false,
            title: "eClub",
        },
    },
    {
        path: "/payment",
        name: "Payment",
        component: () => import("../views/Pay/index.vue"),
        meta: {
            requiresAuth: true,
            title: "Payment",
        },
    },
    {
        path: "/bundlepayment",
        name: "Bundle Payment",
        component: () => import("../views/BundlePayment/index.vue"),
        meta: {
            requiresAuth: true,
            title: "Bundle Payment",
        },
    },
    {
        path: "/clubapplication",
        name: "Club Application",
        component: () => import("../views/ClubApplication/index.vue"),
        meta: {
            requiresAuth: true,
            title: "Club Application"
        }
    },
    {
        path: "/schoolClubProfile",
        name: "SchoolClubProfile",
        component: () => import("../views/SchoolClubProfile/index.vue"),
        meta: {
            requiresAuth: false,
            title: "School Club Profile"
        }
    },
    {
        path: "/student-registration",
        name: "Student Registration",
        component: () => import("../views/StudentRegistration/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Student Registration",
            layout: 'blank'
        }
    },
    {
        path: "/registration-success",
        name: "Registration Success",
        component: () => import("../views/StudentRegistration/success.vue"),
        meta: {
            requiresAuth: false,
            title: "Registration Success",
            layout: 'blank'
        }
    },
    {
        path: "/verify",
        name: "Certificate Verify",
        component: () => import("../views/CertificateVerify/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Certificate Verification",
            layout: 'blank'
        }
    },
    {
        path: "/certificate",
        name: "Public Certificate",
        component: () => import("../views/CertificateDisplay/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Certificate",
            layout: 'blank'
        }
    },
    {
        path: "/verify/:certificateId",
        name: "Certificate Verify With ID",
        component: () => import("../views/CertificateVerify/index.vue"),
        meta: {
            requiresAuth: false,
            title: "Certificate Verification",
            layout: 'blank'
        }
    },
    ...commonRoutes,

];

const router = new VueRouter({
    linkActiveClass: "active",
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth === false) {
        next();
    } else {
        var userId = getUserId();
        if (userId == undefined || userId == "") {
            next({
                path: "/login",
            });
        } else {
            next();
        }
    }
});

export default router;